import { useSelector } from "react-redux";
import SignalR, { SignalRMethod } from "./SignalR";

const Event = {
  NewChatMessage: "CHAT_MESSAGES",
  ChatCountChange: "CHAT_COUNT_CHANGE",
  NewClientChatMessage: "CLIENT_CHAT_MESSAGES",
  ClientChatCountChange: "CLIENT_CHAT_COUNT_CHANGE",
  NotificationCount: "NotificationCount",
  ReportedChatGroup: "CHAT_REPORTED",
  DeleteChatGroup: "CHAT_DELETE"
};

const onNewChatMessageCallbacks = new Map();
const onClientNewChatMessageCallbacks = new Map();
const onChatCountChangeCallbacks = new Map();
const onClientChatCountChangeCallbacks = new Map();
const ReportedChatGroupCallbacks = new Map();
const DeletedChatGroupCallbacks = new Map();

const BuildIdEvent = () => {
  const loginData = useSelector((state) => state?.main?.loginData);

  return {
    sendMessage: (args) =>
      new Promise((resolve, reject) => {
        SignalR.invoke(SignalRMethod.SEND_MESSAGE_TO_CHAT_GROUP, args).then(resolve).catch(reject);
      }),
    sendClientMessage: (args) =>
      new Promise((resolve, reject) => {
        SignalR.invoke(SignalRMethod.SEND_MESSAGE_TO_CLIENT_CHAT_GROUP, args)
          .then(resolve)
          .catch(reject);
      }),
    sendChatGroupDetails: (chatGroupId, isClientChatGroup = false, clientId) =>
      new Promise((resolve, reject) => {
        function HubInvoke(args) {
          if (isClientChatGroup) {
            SignalR.invoke(SignalRMethod.CHANGE_CURRENT_ACTIVE_CLIENT_CHAT_GROUP, args)
              .then(resolve)
              .catch(reject);
          } else {
            SignalR.invoke(SignalRMethod.CHANGE_CURRENT_ACTIVE_GROUP, args)
              .then(resolve)
              .catch(reject);
          }
        }
        getChatGroupDetails(chatGroupId, isClientChatGroup, clientId, loginData)
          .then(HubInvoke)
          .catch(reject);
      }),
    sendReportedChatGroup: (userId, deviceId, chatGroupId) =>
      new Promise((resolve, reject) => {
        SignalR.invoke(SignalRMethod.REPORTED_CHAT_GROUP, [userId, deviceId, chatGroupId])
          .then(resolve)
          .catch(reject);
      }),
    deleteChatGroup: (args) =>
      new Promise((resolve, reject) => {
        SignalR.invoke(SignalRMethod.DELETE_CHAT_GROUP, args).then(resolve).catch(reject);
      })
  };
};

const BuildIdEventListener = {
  onNewChatMessage: (callback, routeKey) => {
    if (!routeKey) {
      console.error("Route key is required for unique constraint");
      return;
    }
    onNewChatMessageCallbacks.set(routeKey, callback);
  },
  onChatCountChange: (callback, routeKey) => {
    if (!routeKey) {
      console.error("Route key is required for unique constraint");
      return;
    }
    onChatCountChangeCallbacks.set(routeKey, callback);
  },
  removeListener: (key) => {
    if (onNewChatMessageCallbacks.has(key)) onNewChatMessageCallbacks.delete(key);
    if (onChatCountChangeCallbacks.has(key)) onChatCountChangeCallbacks.delete(key);
    if (ReportedChatGroupCallbacks.has(key)) ReportedChatGroupCallbacks.delete(key);
  },
  ReportedChatGroup: (callback, routeKey) => {
    if (!routeKey) {
      console.error("Route key is required for unique constraint");
      return;
    }
    ReportedChatGroupCallbacks.set(routeKey, callback);
  }
};

const BuildIdClientEventListener = {
  onNewChatMessage: (callback, routeKey) => {
    if (!routeKey) {
      console.error("Route key is required for unique constraint");
      return;
    }
    onClientNewChatMessageCallbacks.set(routeKey, callback);
  },
  onChatCountChange: (callback, routeKey) => {
    if (!routeKey) {
      console.error("Route key is required for unique constraint");
      return;
    }
    onClientChatCountChangeCallbacks.set(routeKey, callback);
  }
};

function BuildIdEventProcessing(type, data) {
  switch (type) {
    case Event.NewChatMessage:
      onNewChatMessageCallbacks.forEach((callBackFunc) => {
        try {
          callBackFunc(data);
        } catch (err) {
          console.error("BuildIdEventProcessing-> onNewChatMessage callback error:", err);
        }
      });
      break;
    case Event.NewClientChatMessage:
      try {
        onClientNewChatMessageCallbacks.forEach((callBackFunc) => callBackFunc(data));
      } catch (err) {
        console.log("BuildIdEventProcessing-> Error In BuildID Event Processing: ", err);
      }
      break;
    case Event.ChatCountChange:
      onChatCountChangeCallbacks.forEach((callBackFunc) => {
        try {
          callBackFunc(data);
        } catch (err) {
          console.error("BuildIdEventProcessing-> onChatCountChange callback error:", err);
        }
      });
      break;
    case Event.ClientChatCountChange:
      onClientChatCountChangeCallbacks.forEach((callBackFunc) => {
        try {
          callBackFunc(data);
        } catch (err) {
          console.error("BuildIdEventProcessing-> onClientChatCountChange callback error:", err);
        }
      });
      break;
    case Event.NotificationCount:
      break;
    case Event.ReportedChatGroup:
      ReportedChatGroupCallbacks.forEach((callBackFunc) => {
        try {
          callBackFunc(data);
        } catch (err) {
          console.error("BuildIdEventProcessing-> ReportedChatGroup callback error:", err);
        }
      });
      break;
    case Event.DeleteChatGroup:
      DeletedChatGroupCallbacks.forEach((callBackFunc) => {
        try {
          callBackFunc(data);
        } catch (err) {
          console.error("BuildIdEventProcessing-> DeleteChatGroup callback error:", err);
        }
      });
      break;

    default:
      console.error("BUILDID_EVENT : unknown ", JSON.stringify(data));
      break;
  }
}

const getChatGroupDetails = async (chatGroupId, isClientChatGroup, clientId, loginData) => {
  try {
    const userId = loginData?.userInformation?.UserId;
    const deviceid = loginData?.userInformation?.DeviceId;
    if (isClientChatGroup) {
      return [Number(userId), deviceid, Number(chatGroupId) || 0, Number(clientId) || 0];
    } else {
      return [Number(userId), deviceid, Number(chatGroupId) || 0];
    }
  } catch (err) {
    throw err;
  }
};

export { Event, BuildIdEventProcessing, BuildIdEventListener, BuildIdClientEventListener };
export default BuildIdEvent;
